<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="гражданство"
      :is-disabled="isDisabled"
      :state="state"
      :initial-value="value"
      :get-item-by-id="getCitizenship"
      :get-list="getItems"
      :can-create-catalog="canEditCitizenship()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <citizenship
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Citizenship from "./Citizenship.vue";
    import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "CitizenshipSelect",
  components: {CatalogSelect, Citizenship },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getCitizenshipsSearch('');
      return (result && result.data) ? result.data : [];
    },
    async getCitizenship(id) {
      const result = await this.getCitizenshipById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditCitizenship() {
      return this.hasPermission([PERM.CATALOG_CITIZENSHIPS_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Citizenships/CitizenshipSelect.vue